import { Routes } from '@angular/router'

import { environment } from '@demo/env/environment'

export const interactionRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/'
  },

  ...(environment.features['module.free-mode']
    ? ([
        {
          path: 'free',
          loadChildren: () =>
            import('@yoshu-lib/features/interaction-modes/free-mode/free-mode.routes').then(
              (m) => m.default
            ),
          data: { workflow: 'rag' }
        }
      ] as Routes)
    : []),

  { path: '**', redirectTo: '/', pathMatch: 'full' }
]
